import { render } from "./DocPlantUML.vue?vue&type=template&id=fbe07ada"
import script from "./DocPlantUML.vue?vue&type=script&lang=js"
export * from "./DocPlantUML.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__